// extracted by mini-css-extract-plugin
module.exports = {"buttonContainer":"Form-module__buttonContainer___1CBpj","form":"Form-module__form___1IQ2Z","heading":"Form-module__heading___OxDyw","rule":"Form-module__rule___3b-za"};